import { PurchaseOrderAPI } from '@business/api/order';
import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { CompactPurchaseOrderResponse, PurchaseOrderId, PurchaseOrderPageQuery } from './../../entities/order/PurchaseOrderResponse';

export class PurchaseOrderBloc extends BaseBloc {
  private readonly poRepo = new Repository<CompactPurchaseOrderResponse>({
    getItemId: po => po.id,
  });

  readonly purchaseOrders$ = this.poRepo.items$;
  readonly selectPurchaseOrder$ = this.poRepo.selectItem;

  onReset() {
    this.poRepo.reset();
  }

  fetchPurchaseOrders = (query: PurchaseOrderPageQuery) => {
    return PurchaseOrderAPI.fetchPurchaseOrders(query);
  };

  fetchPurchaseOrder = (id: PurchaseOrderId) => {
    return PurchaseOrderAPI.fetchPurchaseOrder(id).pipe(
      this.poRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_order_products_error') }),
    );
  };

  updatePoStatus = (id: PurchaseOrderId, status: string) => {
    return PurchaseOrderAPI.updatePoStatus(id, status).pipe(
      this.poRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_po_status_success'),
      }),
    );
  };
}
